import Core from 'core/js/components/layout-menu/_login-form.js'

/** Only define a pug file if different from the core */

export default Vue.extend({
  extends: Core,
  data() {
    return {
      shouldShowConditions: true
    }
  }
})
